import axios from 'axios'
import jsonp from 'jsonp'

export default {
    install(Vue) {
        Vue.axios = Vue.prototype.$axios = axios
        Vue.jsonp = Vue.prototype.$jsonp = jsonp
    }
}
